import type { AxiosInstance, RawAxiosRequestHeaders, AxiosRequestConfig } from "axios";
import { message } from "antd";

export const _POST = "post";

export const _GET = "get";

export const _DELETE = "delete";

type Method = typeof _POST | typeof _GET | typeof _DELETE;

export interface ApiResult<D> {
  code: number;
  data: D;
  msg: string;
}

export interface ConfigHeaders extends RawAxiosRequestHeaders {
  actionType?: number;
}

export interface RequestApiOptions {
  /** 获取 token 的方法 */
  getToken: () => string;
  /** token 过期跳转路径 */
  loginPath: string;
  /** 成功状态码 */
  successCodes?: number[];
}

type QueryFn<P, R> = (params: P, queryHeaders?: ConfigHeaders) => Promise<ApiResult<R>>;
type RequestConfig = Pick<AxiosRequestConfig, "timeout">;

// 防止并发请求时重复跳转登录页
let isRedirecting = false;

export function createRequestApi(autoRequest: AxiosInstance, options: RequestApiOptions) {
  const { getToken, loginPath, successCodes = [0] } = options;

  function request<R = any, P = any>(
    method: Method,
    url: string,
    headers: ConfigHeaders = {},
    requestConfig: RequestConfig = {}
  ): QueryFn<P, R> {
    return async function (params: P, queryHeaders = {} as ConfigHeaders): Promise<ApiResult<R>> {
      try {
        const config: AxiosRequestConfig = {
          ...requestConfig,
          // 请求方式
          method,
          // 接口url
          url: url,
          // 请求参数
          [method === _GET || method === _DELETE ? "params" : "data"]: params,
          // signal: controller.signal,
          headers: {
            Authorization: getToken(),
            // ycApiRequest headers
            ...headers,
            // return fn headers
            ...queryHeaders,
          },
        };

        /**
         *
         * 请求接口
         *
         * */
        const result = await autoRequest<ApiResult<R>>(config);

        if (successCodes.includes(result.data.code)) {
          return Promise.resolve(result.data);
        }

        if (result.data.code === 10001 && !isRedirecting) {
          isRedirecting = true;
          window.location.href = loginPath;
        }

        message.error(result.data?.msg ?? "网络错误");

        return Promise.reject(result.data);
      } catch (error) {
        console.error("has error", error);

        return Promise.reject(error);
      }
    };
  }

  return request;
}

export type { QueryFn, Method };
